import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Row, Col, ListGroup, Image, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../common/Message";
import CheckoutSteps from "../common/CheckoutSteps";
import Meta from "./../common/Meta";
import { createOrder } from "../../actions/orderActions";
import { currencyFormat } from "./../../utils/currencyFormat";

const PlaceOrderScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const booking = useSelector((state) => state.booking);

  //    Calculate prices
  const addDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  booking.itemsPrice = addDecimals(
    booking.bookingItems.reduce((acc, item) => acc + item.price * item.qty, 0)
  );

  booking.deliveryPrice = addDecimals(booking.itemsPrice > 100 ? 0 : 100);
  booking.taxPrice = addDecimals(
    Number((0.15 * booking.itemsPrice).toFixed(2))
  );
  booking.totalPrice = (
    Number(booking.itemsPrice) +
    Number(booking.deliveryPrice) +
    Number(booking.taxPrice)
  ).toFixed(2);

  const orderCreate = useSelector((state) => state.orderCreate);
  const { order, success, error } = orderCreate;

  useEffect(() => {
    if (success) {
      console.log(order._id);
      navigate(`/order/${order._id}`);
    }
  }, [navigate, success, order]);

  const placeOrderHandler = () => {
    console.log(booking.deliveryAddress);
    dispatch(
      createOrder({
        orderItems: booking.bookingItems,
        deliveryAddress: booking.deliveryAddress,
        paymentMethod: booking.paymentMethod,
        itemsPrice: booking.itemsPrice,
        deliveryPrice: booking.deliveryPrice,
        taxPrice: booking.taxPrice,
        totalPrice: booking.totalPrice,
      })
    );
  };

  return (
    <>
      <Meta title="Place order" />
      <CheckoutSteps step1 step2 step3 step4 />
      <Row className="text-dark">
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item variant="light">
              <h2>Delivery</h2>
              <p>
                <strong>Address:</strong>
                {booking.deliveryAddress.address},{" "}
                {booking.deliveryAddress.city}{" "}
              </p>
            </ListGroup.Item>

            <ListGroup.Item variant="light">
              <h2>Payment Method</h2>
              <strong>Method: </strong>
              {booking.paymentMethod}
            </ListGroup.Item>

            <ListGroup.Item variant="light">
              <h2>Order Items</h2>
              {booking.bookingItems.length === 0 ? (
                <Message>Your booking is empty</Message>
              ) : (
                <ListGroup variant="flush">
                  {booking.bookingItems.map((item, index) => (
                    <ListGroup.Item key={index} variant="light">
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item.image}
                            alt={item.name}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <Link
                            to={`/product/${item.product}`}
                            className="link"
                          >
                            {item.name}
                          </Link>
                        </Col>
                        <Col md={4}>
                          <strong className="price">
                            {item.qty} x{currencyFormat(item.price)} =
                            {currencyFormat((item.qty * item.price).toFixed(2))}
                          </strong>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item variant="light">
                <h2>Order Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item variant="light">
                <Row>
                  <Col>Items</Col>
                  <Col>{currencyFormat(booking.itemsPrice)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item variant="light">
                <Row>
                  <Col>Delivery fee</Col>
                  <Col>{currencyFormat(booking.deliveryPrice)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item variant="light">
                <Row>
                  <Col>Tax</Col>
                  <Col>{currencyFormat(booking.taxPrice)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item variant="light">
                <Row>
                  <Col>Total</Col>
                  <Col>{currencyFormat(booking.totalPrice)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item variant="light">
                {error && <Message variant="danger">{error}</Message>}
              </ListGroup.Item>
              <ListGroup.Item variant="light">
                <Button
                  type="buttom"
                  className="btn-block"
                  disabled={booking.bookingItems === 0}
                  onClick={placeOrderHandler}
                >
                  Place Order
                </Button>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PlaceOrderScreen;
